import actionCreators from 'spark-state/actionCreators';

export const REQUEST_RECEIVED = 'HTTP_REQ.REQUEST_RECEIVED';
export const SEND_REQUEST = 'HTTP_REQ.SEND_REQUEST';
export const REQUEST_SUCCESS = 'HTTP_REQ.REQUEST_SUCCESS';
export const REQUEST_ERROR = 'HTTP_REQ.REQUEST_ERROR';
export const REFRESH_TOKEN = 'HTTP_REQ.REFRESH_TOKEN';

export const requestReceived = actionCreators.log(REQUEST_RECEIVED);

export const sendRequest = request => ({
    type: SEND_REQUEST,
    request
});

export const requestSuccess = response => ({ type: REQUEST_SUCCESS, response });
export const requestError = (error, request) => ({
    type: REQUEST_ERROR,
    error,
    request
});
